// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  SimulationOpcUaStep,
  SimulationOpcUaStepT,
  verifySimulationOpcUaStep,
} from "./simulation-opc-ua-step";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Serve an OPC UA domain and drive its node values from a script.
 */
export class SimulationOpcUaScript implements flatbuffers.IUnpackableObject<SimulationOpcUaScriptT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationOpcUaScript {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationOpcUaScript(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationOpcUaScript,
  ): SimulationOpcUaScript {
    return (obj || new SimulationOpcUaScript()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationOpcUaScript(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationOpcUaScript,
  ): SimulationOpcUaScript {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationOpcUaScript()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  domainAssetId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Namespace URI the server registers; empty means the simulator default.
   */
  namespaceUri(): string | null;
  namespaceUri(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  namespaceUri(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  steps(index: number, obj?: SimulationOpcUaStep): SimulationOpcUaStep | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new SimulationOpcUaStep()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  stepsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Start the script again after its last step.
   */
  loop(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * Length of one pass, in milliseconds; 0 means the last step's `at_ms`.
   */
  periodMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startSimulationOpcUaScript(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addDomainAssetId(builder: flatbuffers.Builder, domainAssetIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, domainAssetIdOffset, 0);
  }

  static addNamespaceUri(builder: flatbuffers.Builder, namespaceUriOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, namespaceUriOffset, 0);
  }

  static addSteps(builder: flatbuffers.Builder, stepsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, stepsOffset, 0);
  }

  static createStepsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startStepsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addLoop(builder: flatbuffers.Builder, loop: boolean) {
    builder.addFieldInt8(3, +loop, +true);
  }

  static addPeriodMs(builder: flatbuffers.Builder, periodMs: number) {
    builder.addFieldInt32(4, periodMs, 0);
  }

  static endSimulationOpcUaScript(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // domain_asset_id
    return offset;
  }

  static createSimulationOpcUaScript(
    builder: flatbuffers.Builder,
    domainAssetIdOffset: flatbuffers.Offset,
    namespaceUriOffset: flatbuffers.Offset,
    stepsOffset: flatbuffers.Offset,
    loop: boolean,
    periodMs: number,
  ): flatbuffers.Offset {
    SimulationOpcUaScript.startSimulationOpcUaScript(builder);
    SimulationOpcUaScript.addDomainAssetId(builder, domainAssetIdOffset);
    SimulationOpcUaScript.addNamespaceUri(builder, namespaceUriOffset);
    SimulationOpcUaScript.addSteps(builder, stepsOffset);
    SimulationOpcUaScript.addLoop(builder, loop);
    SimulationOpcUaScript.addPeriodMs(builder, periodMs);
    return SimulationOpcUaScript.endSimulationOpcUaScript(builder);
  }

  unpack(): SimulationOpcUaScriptT {
    return new SimulationOpcUaScriptT(
      this.domainAssetId() !== null ? this.domainAssetId()!.unpack() : null,
      this.namespaceUri(),
      this.bb!.createObjList<SimulationOpcUaStep, SimulationOpcUaStepT>(
        this.steps.bind(this),
        this.stepsLength(),
      ),
      this.loop(),
      this.periodMs(),
    );
  }

  unpackTo(_o: SimulationOpcUaScriptT): void {
    _o.domainAssetId = this.domainAssetId() !== null ? this.domainAssetId()!.unpack() : null;
    _o.namespaceUri = this.namespaceUri();
    _o.steps = this.bb!.createObjList<SimulationOpcUaStep, SimulationOpcUaStepT>(
      this.steps.bind(this),
      this.stepsLength(),
    );
    _o.loop = this.loop();
    _o.periodMs = this.periodMs();
  }

  unpackFields(...fields: string[]): SimulationOpcUaScriptT {
    const t = new SimulationOpcUaScriptT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("domain_asset_id")) {
      t.domainAssetId = this.domainAssetId() !== null ? this.domainAssetId()!.unpack() : null;
    }
    if (fieldSet.has("namespace_uri")) {
      t.namespaceUri = this.namespaceUri();
    }
    if (fieldSet.has("steps")) {
      t.steps = this.bb!.createObjList<SimulationOpcUaStep, SimulationOpcUaStepT>(
        this.steps.bind(this),
        this.stepsLength(),
      );
    }
    if (fieldSet.has("loop")) {
      t.loop = this.loop();
    }
    if (fieldSet.has("period_ms")) {
      t.periodMs = this.periodMs();
    }
    return t;
  }
}

export class SimulationOpcUaScriptT implements flatbuffers.IGeneratedObject {
  constructor(
    public domainAssetId: UuidT | null = null,
    public namespaceUri: string | Uint8Array | null = null,
    public steps: SimulationOpcUaStepT[] = [],
    public loop: boolean = true,
    public periodMs: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.domainAssetId === null || this.domainAssetId === undefined) {
      throw new Error('Required field "domain_asset_id" is not set');
    }
    const domainAssetId = this.domainAssetId !== null ? this.domainAssetId!.pack(builder) : 0;
    const namespaceUri = this.namespaceUri !== null ? builder.createString(this.namespaceUri!) : 0;
    const steps = SimulationOpcUaScript.createStepsVector(
      builder,
      builder.createObjectOffsetList(this.steps),
    );

    return SimulationOpcUaScript.createSimulationOpcUaScript(
      builder,
      domainAssetId,
      namespaceUri,
      steps,
      this.loop,
      this.periodMs,
    );
  }

  clone(): SimulationOpcUaScriptT {
    const obj = new SimulationOpcUaScriptT();
    obj.domainAssetId = this.domainAssetId !== null ? this.domainAssetId!.clone() : null;
    obj.namespaceUri = this.namespaceUri;
    obj.steps = this.steps.map((e) => e.clone());
    obj.loop = this.loop;
    obj.periodMs = this.periodMs;
    return obj;
  }

  equals(other: SimulationOpcUaScriptT): boolean {
    if (this.domainAssetId !== null && other.domainAssetId !== null) {
      if (!this.domainAssetId!.equals(other.domainAssetId!)) return false;
    } else if (this.domainAssetId !== other.domainAssetId) return false;
    if (this.namespaceUri !== other.namespaceUri) return false;
    if (this.steps.length !== other.steps.length) return false;
    for (let i = 0; i < this.steps.length; i++) {
      const a = this.steps[i];
      const b = other.steps[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.loop !== other.loop) return false;
    if (this.periodMs !== other.periodMs) return false;
    return true;
  }
}

export function verifySimulationOpcUaScript(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "domain_asset_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationOpcUaStep);
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 4);
  } finally {
    verifier.popDepth();
  }
}
